import React from 'react';
import { CheckIcon, LockIcon, RefreshCwIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { offerLines } from '../../data/content';
const perks = ['Accesso Immediato', 'Pagamento Una Tantum', 'Accesso a Vita', 'Garanzia 7 Giorni'];
export function OfferSection() {
  return <section id="offerta" className="w-full bg-cream" data-id="element-238" data-mp="6hq5nhawopdm">
      <div className="mx-auto w-full max-w-3xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-239" data-mp="6jb076x808bh">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-teal" data-id="element-240" data-mp="1ox04r7m5d0h">
          La tua offerta
        </p>
        <h2 className="mt-3 text-balance text-center font-display text-[30px] font-black leading-[1.1] tracking-[-0.02em] text-plum-deep sm:text-4xl" data-id="element-241" data-mp="3nxpul3m2wamz">
          Ecco tutto ciò che riceverai oggi
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white ring-1 ring-ink/10" data-id="element-242" data-mp="3ex9snykzhbk8">
          <ul className="divide-y divide-ink/10" data-id="element-243" data-mp="1as0n02sn5izy">
            {offerLines.map(line => <li key={line.label} className="flex items-start gap-3 px-4 py-3.5 sm:px-6 sm:py-4" data-id="element-244" data-mp="1aq7cuditkgn7">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-245" data-mp="1fkk2546z8m6v" />
                <span className="flex-1 text-[14.5px] font-medium leading-snug text-ink/80 sm:text-base" data-id="element-246" data-mp="10rzzs5rniiqh">
                  {line.label}
                </span>
                <span className="shrink-0 text-[14.5px] font-bold text-ink/45 line-through sm:text-base" data-id="element-247" data-mp="1tjtfzx7pn47o">
                  {line.value}
                </span>
              </li>)}
          </ul>

          <div className="flex items-center justify-between gap-3 bg-plum-soft px-4 py-4 sm:px-6" data-id="element-248" data-mp="1kh245waxa6fi">
            <span className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-plum-deep" data-id="element-249" data-mp="1ohubgk08i195">
              Valore totale
            </span>
            <span className="font-display text-2xl font-black text-plum-deep line-through decoration-plum/40" data-id="element-250" data-mp="d49ymsbh2xh2">
              592 €
            </span>
          </div>
        </div>

        <p className="mt-7 text-center text-[16px] font-semibold leading-relaxed text-ink/75 sm:text-lg" data-id="element-251" data-mp="2ft0a1wextah6">
          Ma oggi non pagherai 592 €. E non pagherai nemmeno 297 €.
        </p>

        <div className="mt-6 rounded-3xl bg-plum-deep p-6 sm:p-8" data-id="element-252" data-mp="25zb2kyausm19">
          <p className="text-center text-[11.5px] font-extrabold uppercase tracking-[0.18em] text-white/60" data-id="element-253" data-mp="210zscmgnc9ii">
            Accesso immediato per soli
          </p>
          <p className="mt-2 text-center font-display text-[72px] font-black leading-none text-gold sm:text-8xl" data-id="element-254" data-mp="1s1cqjzk091ox">
            19 €
          </p>

          <p className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-white/10 px-3 py-2.5 text-center text-[12.5px] font-semibold text-white/80 sm:text-sm" data-id="element-255" data-mp="1n31dzh2bsd30">
            <RefreshCwIcon className="h-4 w-4 shrink-0 text-teal-light" aria-hidden="true" data-id="element-256" data-mp="3hf803awrcea3" />
            Cambio di moneta automatico nella tua valuta locale
          </p>

          <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-257" data-mp="3kygjcm8sydc9">
            {perks.map(perk => <li key={perk} className="flex items-start gap-2" data-id="element-258" data-mp="3oza8tk1w8079">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-259" data-mp="3oxpcppzxk97a" />
                <span className="text-[13px] font-semibold leading-snug text-white/85 sm:text-sm" data-id="element-260" data-mp="3tslhzru6gt2c">
                  {perk}
                </span>
              </li>)}
          </ul>

          <p className="mt-5 text-center text-[13.5px] leading-relaxed text-white/60 sm:text-sm" data-id="element-261" data-mp="3215l94ywppye">
            Un solo pagamento. Nessun abbonamento. Nessuna commissione mensile. Accesso a vita.
          </p>

          <div className="mt-6" data-id="element-262" data-mp="3b23ty0kailnb">
            <CTAButton label="Sì, voglio il progetto completo" variant="gold" data-id="element-263" data-mp="3fzn6mw1caqd5" />
          </div>

          <div className="mt-6" data-id="element-264" data-mp="qa1wd8608lgi">
            <Countdown tone="dark" data-id="element-265" data-mp="q90d4geu4snp" />
          </div>

          <div className="mt-5" data-id="element-266" data-mp="v8wjgmb08w6f">
            <ScarcityBar tone="dark" data-id="element-267" data-mp="v7tr09y1aloe" />
          </div>

          <p className="mt-5 inline-flex w-full items-center justify-center gap-2 text-center text-[12px] font-medium text-white/50" data-id="element-268" data-mp="vapm7qihyw95">
            <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-269" data-mp="1z7ibjpwx47fo" />
            Checkout sicuro • Pagamento crittografato
          </p>
        </div>
      </div>
    </section>;
}